import * as React from 'react';
import { DOB, LAST_NAME, POSTCODE, USERNAME } from 'ts/constants/UrlParams';
import { findAccountForManualRegWithCaptcha } from 'ts/services/find-account/FindAccountService';
import { AccountNumberPage } from 'ts/passwordless-login/components/pages/account-number/AccountNumberPage';
import { Content } from 'ts/passwordless-login/components/pages/account-number/Interfaces';
import { sendOtcAndRedirect } from './Actions';
import { navigateToErrorPage } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';
import { ERROR_CODES } from 'ts/passwordless-login/components/pages/error/ErrorCodes';
import { ErrorFlow } from 'ts/passwordless-login/components/pages/error/ErrorFlow';
import { RouteComponentProps } from 'react-router-dom';
import { History, Location } from 'history';

const content: Content = {
  analytics: {
    navigation: {
      friendlyUri: 'originenergy:my-account:auth:manual-reg-verify-account',
    },
    errorForm: {
      formName: 'auth:manual-reg',
      errorMessage: 'auth:manual-reg:invalid-account-number',
      errorCode: 'invalid-account-number',
    },
    interaction: {
      click: {
        appName: 'auth:manual-reg',
      },
    },
  },
  copy: {
    headingText: 'We need to match you up',
    infoText: 'Please enter your account number from your bill or contract pack',
    alertBoxText:
      "Hmm, we can't find an account linked to those details. Please check and try again, or [contact us](LIVECHAT).",
  },
};

const nextAction = (history: History, location: Location) => async (username: string) => {
  const userProvidedUsername = new URLSearchParams(location.search).get(USERNAME);
  sendOtcAndRedirect(history, username, userProvidedUsername, true);
};

const errorPageAction = (history: History) => (statusCode: number) => {
  const errorCode =
    statusCode === 422
      ? ERROR_CODES.MANUAL_REG_SAP_EMAIL_ERROR
      : ERROR_CODES.MANUAL_REG_ACCOUNT_SEARCH;
  navigateToErrorPage(errorCode, ErrorFlow.manualReg, '', history, true);
};

const findAccountAction = (
  lastName: string,
  dob: string,
  postcode: string,
  accountNumber: string,
  userProvidedEmail: string,
) => {
  return findAccountForManualRegWithCaptcha(
    lastName,
    dob,
    postcode,
    accountNumber,
    userProvidedEmail,
  );
};

const ManualRegAccountNumberPage: React.FC<RouteComponentProps> = ({ history, location }) => {
  const searchParams = new URLSearchParams(location.search);
  return (
    <AccountNumberPage
      userProvidedEmail={searchParams.get(USERNAME)}
      findAccountAction={findAccountAction}
      lastName={searchParams.get(LAST_NAME)}
      dob={searchParams.get(DOB)}
      postcode={searchParams.get(POSTCODE)}
      errorPageAction={errorPageAction(history)}
      content={content}
      history={history}
      nextAction={nextAction(history, location)}
    />
  );
};

export { ManualRegAccountNumberPage };
